import React, {useEffect, useId, useRef, useState} from 'react';
import {matchingOptions} from '../utils/conversionForm';

export default function ConversionSearchSelect({label, value, options, onChange, disabled, placeholder, emptyMessage}) {
  const id = useId();
  const root = useRef(null);
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(0);
  const selected = options.find(option => option.value === value);
  const matches = matchingOptions(options, query);
  useEffect(() => {
    const close = event => { if (!root.current?.contains(event.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);
  useEffect(() => {setOpen(false); setQuery(''); setActive(0);}, [value, disabled]);
  const choose = option => {onChange(option.value); setOpen(false); setQuery('');};
  return <div ref={root} style={{position:'relative'}}>
    <input id={id} className="form-control" role="combobox" aria-label={label}
      aria-expanded={open} aria-controls={id+'-list'} aria-autocomplete="list"
      aria-activedescendant={open && matches[active] ? id+'-'+active : undefined}
      autoComplete="off" disabled={disabled}
      placeholder={placeholder} value={open ? query : (selected?.label || '')}
      onFocus={()=>{setQuery('');setActive(0);setOpen(true);}}
      onChange={event=>{setQuery(event.target.value);setActive(0);setOpen(true);}}
      onBlur={event=>{if(!event.currentTarget.parentElement.contains(event.relatedTarget))setOpen(false);}}
      onKeyDown={event=>{
        if(event.key==='Escape'){event.preventDefault();setOpen(false);}
        if(event.key==='ArrowDown'){event.preventDefault();setOpen(true);setActive(n=>Math.min(n+1,Math.max(0,matches.length-1)));}
        if(event.key==='ArrowUp'){event.preventDefault();setOpen(true);setActive(n=>Math.max(0,n-1));}
        if(event.key==='Enter'){event.preventDefault();if(open && matches[active])choose(matches[active]);}
      }}/>
    {value && !disabled && <button type="button" className="btn btn-ghost btn-sm" aria-label={'Clear '+label} onClick={()=>{onChange('');setQuery('');}}>Clear selection</button>}
    {open && <div id={id+'-list'} role="listbox" aria-label={label} style={{position:'absolute',zIndex:30,background:'#fff',border:'1px solid #A8893D',borderRadius:6,width:'100%',maxHeight:240,overflowY:'auto',boxShadow:'0 4px 12px #0002'}}>
      {matches.map((option,index)=><div key={option.value} id={id+'-'+index} role="option" aria-selected={option.value===value}
        onMouseDown={event=>event.preventDefault()} onClick={()=>choose(option)} onMouseEnter={()=>setActive(index)}
        style={{padding:'10px 12px',cursor:'pointer',background:active===index?'#F2EFE7':'#fff',borderBottom:'1px solid #eee'}}>{option.label}</div>)}
      {!matches.length && <div style={{padding:12}}>{query ? 'No matching results.' : emptyMessage || 'No options available.'}</div>}
    </div>}
  </div>;
}
